import type { ProjectUploadsDict } from '../en/projectUploads';

export const projectUploads: ProjectUploadsDict = {
  dialog: {
    title: (count: number) => (count === 1 ? 'Laddar upp fil …' : `Laddar upp ${count} filer …`),
    progress: (done: number, total: number) => `${done} av ${total} klara`,
    waiting: 'Väntar',
    uploaded: 'Uppladdad',
    failed: 'Misslyckades',
  },
  toasts: {
    uploadedOne: (name: string) => `"${name}" laddades upp`,
    uploadedMany: (count: number) => `${count} filer laddades upp`,
    failedOne: (name: string) => `Det gick inte att ladda upp "${name}"`,
    failedSome: (failed: number, total: number) =>
      failed === total
        ? `Ingen av de ${total} filerna kunde laddas upp`
        : `${failed} av ${total} filer kunde inte laddas upp`,
    skippedType: 'Hoppades över: endast PDF-, Word-, text- och Markdown-filer kan läggas till',
    skippedSize: (mb: number) => `Hoppades över: filer får vara högst ${mb} MB`,
    skippedEmpty: 'Hoppades över: tomma filer och mappar kan inte läggas till',
    skippedCount: (max: number) => `Hoppades över: högst ${max} filer kan läggas till åt gången`,
    busy: 'Vänta tills den pågående uppladdningen är klar',
  },
  errors: {
    tooLarge: (mb: number) => `Filen är större än ${mb} MB`,
    generic: 'Uppladdningen misslyckades',
  },
};
